import React from "react";
import Typography from "@material-ui/core/Typography";
// import Card from "@material-ui/core/Card";
// import CardContent from "@material-ui/core/CardContent";
// import Button from "@material-ui/core/Button";
import LocationIcon from "@material-ui/icons/LocationOnOutlined";
import PhoneIcon from "@material-ui/icons/PhoneOutlined";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <footer className="p-3 shadow">
        <div className="row">
          <div className="col-md-4 p-3 text-center">
            <Typography variant="body2" className="text-center rtl">
              <LocationIcon />
              آدرس : قدوسی غربی ، نبش کوچه ۶ علیرضایی ، کلاب کودک گفتگو
            </Typography>
            <Typography variant="body2" className="text-center rtl mt-3">
              <PhoneIcon /> تلفن تماس : ۰۹۱۷۰۷۲۱۳۴۲
            </Typography>
          </div>
          <div className="col-md-4 p-3 text-center">
            <a
              referrerPolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=213571&amp;Code=HBXYps6YhJ3QOlvlsqfb"
            >
              <img
                referrerPolicy="origin"
                src="https://Trustseal.eNamad.ir/logo.aspx?id=213571&amp;Code=HBXYps6YhJ3QOlvlsqfb"
                alt=""
                style={{ cursor: "pointer" }}
                id="HBXYps6YhJ3QOlvlsqfb"
              />
            </a>
            {/*<a*/}
            {/*  referrerPolicy="origin"*/}
            {/*  target="_blank"*/}
            {/*  href="https://trustseal.enamad.ir/?id=213571&amp;Code=HBXYps6YhJ3QOlvlsqfb"*/}
            {/*>*/}
            {/*  <img*/}
            {/*    referrerPolicy="origin"*/}
            {/*    src="https://Trustseal.eNamad.ir/logo.aspx?id=213571&amp;Code=HBXYps6YhJ3QOlvlsqfb"*/}
            {/*    alt=""*/}
            {/*    style={{ cursor: "pointer" }}*/}
            {/*    id="HBXYps6YhJ3QOlvlsqfb"*/}
            {/*  />*/}
            {/*</a>*/}
          </div>
          <div className="col-md-4 p-3 text-justify">
            در گفتگو کودکان زندگی کردن را می آموزند ! گفتگو، خانه ای امن برای
            کودکان، والدین و مربیان است. ما با هم و در کنار هم، برای پرورش نسلی
            سالم، خلاق و بانشاط تلاش می کنیم. در گفتگو، رابطه ای تنگاتنگ بین
            «آموزش» و «پرورش» برقرار است و همانقدر که به یادگیری مهارتهای شناختی
            کودک اهمیت می دهیم به پرورش روان کودک هم توجه داریم.
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
